import { render, staticRenderFns } from "./Limitare_rezervari_list.vue?vue&type=template&id=661d3618&scoped=true"
import script from "./Limitare_rezervari_list.vue?vue&type=script&lang=js"
export * from "./Limitare_rezervari_list.vue?vue&type=script&lang=js"
import style0 from "./Limitare_rezervari_list.vue?vue&type=style&index=0&id=661d3618&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d3618",
  null
  
)

export default component.exports